import React, { Component } from 'react';
import { withNamespaces } from 'react-i18next';
import { withRouter } from 'react-router-dom';

import { Container, Button } from 'reactstrap';
import UpdateDmxDeviceProfileForm from '../../components/Forms/UpdateDmxDeviceProfileForm';

class DmxDeviceProfileDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      profile: this.props.location.state || null,
    };
  }

  componentDidMount() {
    if (!this.state.profile) {
      this.props.history.push('/dmxDeviceProfiles');
    }
  }

  goBack(event) {
    event.preventDefault();
    this.props.history.push('/dmxDeviceProfiles');
  }

  render() {
    const { profile } = this.state;
    if (!profile) return null;
    return (
      <div className="user-management">
        <Container fluid>
          <Button className="btn btn-primary waves-effect waves-light usersButtons" onClick={(event) => this.goBack(event)}>
            <i className="fas fa-arrow-left"></i>
          </Button>
          <UpdateDmxDeviceProfileForm profile={profile} />
        </Container>
      </div>
    );
  }
}

export default withRouter(withNamespaces()(DmxDeviceProfileDetails));
